export default __webpack_public_path__ + "static/media/d8.55343d50.png";